import React, { Fragment, Component } from "react";
import { Router, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import BlogContainer from "../Containers/Blog/BlogListContainer";
import SupportContainer from "../Containers/Support/SupportContainer";
import BlogPostContainer from "../Containers/Blog/BlogPostContainer";
import NotFoundContainer from "../Containers/NotFoundContainer";
import strings from "../LocalizedStrings";
import NewRouter from "./NewRouter";

const history = createBrowserHistory();

class AppRouter extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      language: "en",
    };
  }

  componentDidMount() {
    this.initialLanguageSetup();
  }

  setLanguage = (language: string) => {
    strings.setLanguage(language);
    this.setState({ language });
  };

  initialLanguageSetup = () => {
    const language = strings.getLanguage();
    if (language !== "es" && language !== "en") {
      strings.setLanguage("en");
      this.setState({ language: "en" });
    } else {
      strings.setLanguage(language);
      this.setState({ language });
    }
  };

  render() {
    const { language } = this.state;
    return (
      <Router history={history}>
        <Fragment>
          <Switch>
            {/* <NewRouter
              path="/:slug"
              exact
              component={BlogPostContainer}
              onLanguageChange={this.setLanguage}
              language={language}
              history={history}
            />
            <NewRouter
              path="/"
              exact
              component={BlogContainer}
              onLanguageChange={this.setLanguage}
              language={language}
              history={history}
            /> */}
            <NewRouter
              path="/:slug"
              exact
              component={SupportContainer}
              onLanguageChange={this.setLanguage}
              language={language}
              history={history}
            />
            <NewRouter
              path="/"
              exact
              component={SupportContainer}
              onLanguageChange={this.setLanguage}
              language={language}
              history={history}
            />
            <NewRouter
              component={NotFoundContainer}
              onLanguageChange={this.setLanguage}
              language={language}
              history={history}
            />
          </Switch>
        </Fragment>
      </Router>
    );
  }
}

export default AppRouter;
